import {
  Grid,
  Typography,
  Button,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import AddClientDialog from '../components/AddClientDialog';
import ClientListing from '../components/ClientListing';
import { userStyles } from '../styles';

interface ClientTabProps extends WithStyles<typeof userStyles> {}

class ClientTab extends Component<ClientTabProps> {

  render() {
    return (
      <div>
        {/* {this.renderClientHeader()} */}
        {/* <ClientListing /> */}
        {/* <AddClientDialog /> */}
        {/* @Rittick please enable this dialog on add new client button */}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(userStyles)(ClientTab));
